import { render } from "./MenuProducts.vue?vue&type=template&id=40a55f84&scoped=true"
import script from "./MenuProducts.vue?vue&type=script&lang=js"
export * from "./MenuProducts.vue?vue&type=script&lang=js"

import "./MenuProducts.vue?vue&type=style&index=0&id=40a55f84&scoped=true&lang=css"

import exportComponent from "D:\\Documents\\Development\\carnitas\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a55f84"]])

export default __exports__